module.exports = __webpack_public_path__ + "static/media/reblozyl-graphic-2.dec5376a.png";